




































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";

import ChannelListTabs from "../../tabs/channels/channel-list-tabs.vue";
import StandartTable from "@/components/tables/standart-table.vue";

interface ISortColumn {
  name: number;
  channelType: number;
  show: number;
  sort_order: number;
}

@Component({
  components: {
    "channel-table": ChannelListTabs,
    StandartTable,
  },
})
export default class FullChannelList extends Vue {
  @Prop({ type: Array, default: () => [] }) channels!: Array<IChannel>;
  @Prop({ type: Object, default: null }) channel!: IChannel | null;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: Array, default: () => [] }) contentTypes!: Array<IContentType>;

  @Prop({ type: String, default: "" }) sortKey!: string;
  @Prop({ type: Object, default: null }) sortOrder!: ISortColumn;

  onUpdateChannel(data: Partial<IChannel>, id: string): void {
    this.$emit("updateChannel", data, id);
  }
}
